import { createContext, useContext } from 'react';

export interface AppNavContextType {
  navigate: (path: string, filters?: Record<string, string>) => void;
  routeFilters: Record<string, string>;
}

export const AppNavContext = createContext<AppNavContextType>({
  navigate: () => {},
  routeFilters: {},
});

export function useAppNav(): AppNavContextType {
  return useContext(AppNavContext);
}
